import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import { isNull } from "@/functions/Util";

export default class UnidadeMedidaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }
    
    validate(model, refs) {
        let validated = true;
        
        if (isNull(model.idpacote)) {
            refs.pacoteInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message("error", 'error-selecionar-pacote-kit', true));
        }
        if (isNull(model.idtabpreco)) {
            refs.tabPrecoInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message("error", 'msg-erro-desc-qtd-tabpreco', true));
        }
        if (isNull(model.idunidademedida)) {
            refs.unitMedidaInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message("error", 'msg-obrigatorio-unidademedida', true));
        }
        if(!(isNull(model.qtdemaximo) || isNull(model.qtdeminimo)) && model.qtdemaximo < model.qtdeminimo) {
            refs.qtdMaxInput.focusedOut = true;
            refs.qtdMinInput.focusedOut = true; 
            validated = false;
            this.showMessage(new Message("error", 'error-qtd-min-maior-qtd-max', true));
        }
        return validated;
    }
}